export default {

    SET_CART: function (state, cart) {
        state.cart = cart;
    },

    SET_PRICE: function (state, total_price) {
        state.total_price = total_price;
    },
    
    ADD_CART: function ( state, cart){
        let shop = state.cart
        let item = state.cart.filter(element => element.id == cart.id)

        if(item.length == 0){
            shop.push(cart)
        }
        state.cart = shop
    }
};